export default "__VITE_ASSET__DEkIAJ57__"